export function useHomeAppChromeQuery(): never {
	throw new Error('Home must provide an AppChrome query before enabling GlobalRoot chrome');
}
